/**
 * Linea de estado del pedido (ADM-09): los cuatro pasos de `pasosPedido`,
 * unidos por una barra que se pinta hasta el ultimo paso cumplido.
 *
 * El estado de cada paso va tambien en texto para lectores de pantalla: el
 * color y el icono solos no lo dicen.
 */
import type { PedidoAdminDetalle } from '@elcarpintero/compartido';

import { fechaHora } from '../../utilidades/formato';
import { type EstadoPaso, pasosPedido } from '../../utilidades/pasos-pedido';
import { Icono, type NombreIcono } from '../comunes/Icono';

export interface PasosPedidoProps {
  pedido: PedidoAdminDetalle;
}

const ICONO: Record<EstadoPaso, NombreIcono | null> = {
  hecho: 'check',
  actual: 'reloj',
  fallido: 'alerta',
  pendiente: null,
};

const LECTOR: Record<EstadoPaso, string> = {
  hecho: 'cumplido',
  actual: 'en espera',
  fallido: 'con problema',
  pendiente: 'pendiente',
};

export function PasosPedido({ pedido }: PasosPedidoProps) {
  const pasos = pasosPedido(pedido);

  return (
    <section className="pasos-pedido-seccion" aria-labelledby="pedido-estado">
      <h3 id="pedido-estado" className="pasos-pedido-titulo">
        Estado del pedido
      </h3>
      <ol className="pasos-pedido">
        {pasos.map((paso) => {
          const icono = ICONO[paso.estado];
          return (
            <li
              key={paso.nombre}
              className={`paso-pedido ${paso.estado}`}
              aria-current={paso.estado === 'actual' ? 'step' : undefined}
            >
              <span className="paso-pedido-marca" aria-hidden="true">
                {icono !== null ? <Icono nombre={icono} /> : null}
              </span>
              <span className="n">
                {paso.nombre}
                <span className="solo-lectores">, {LECTOR[paso.estado]}</span>
              </span>
              {paso.fecha !== null ? (
                <time className="d" dateTime={paso.fecha}>
                  {fechaHora(paso.fecha)}
                </time>
              ) : (
                <span className="d">{paso.detalle}</span>
              )}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
